(ns frontend.view.modals.new-kpi-report.events
  (:require [common.localization :as loc]
            [frontend.conn :as conn]
            [promesa.core :as p]
            [common.entity :as entity]
            [frontend.state.current-session :as session]
            [clojure.string :as string]
            [frontend.logging :as logging]))

(defn their-contact-str [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str " " first-name)
      :last-name (str " " last-name)
      :full-name (str " " first-name " " last-name)
      "")))

(defn our-contact-str [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str "\n" first-name)
      :last-name (str "\n" last-name)
      :full-name (str "\n" first-name " " last-name)
      "")))

(defn construct-email [category member]
  (let [{:keys [kpi-member/asset
                kpi-member/account
                common/owner]} member
        {:keys [kpi-category/email-title
                kpi-category/email-copy
                kpi-category/email-greeting
                kpi-category/email-greeting-contact
                kpi-category/email-ending
                kpi-category/email-ending-contact]} category
        sender-email "reporting@zapflow.com"

        session-entities @session/entities
        tenant @session/tenant
        asset (get session-entities asset)
        owner (get session-entities owner)
        account (get session-entities account)

        email-greeting-contact-str (their-contact-str email-greeting-contact account)
        full-greeting (str email-greeting email-greeting-contact-str)
        our-contact-email (-> owner :account/email)
        email-ending-contact-str (our-contact-str email-ending-contact owner)
        full-ending (str email-ending email-ending-contact-str)

        tenant-name (:tenant/name tenant)
        ending-note-1 (loc/tr :email-template-ending-note-1 [(entity/display-string owner) tenant-name])
        ending-note-2 (loc/tr :email-template-ending-note-2 [tenant-name])
        ending-note (str ending-note-1 " " sender-email " " ending-note-2)
        ;;ending-note-unformatted (->> config/config :default :kpi-category :kpi-category/email-ending-note)
        ;;ending-note (format ending-note-unformatted (entity/display-string owner) company-name company-name)
        full-email (str ""
                        (when-not (empty? full-greeting)
                          (str full-greeting ",\n\n"))
                        email-copy
                        "\n\n"
                        full-ending
                        "\n\n"
                        ending-note)]
    full-email))

(defn reset-state! [state category member]
  (let [{:keys [kpi-category/email-title]} category
        email-copy (construct-email category member)]
    (swap! state assoc
           :kpi-report/email-title email-title
           :kpi-report/email-copy email-copy)))

(defn create-report! [state cycle company close!]
  (let [;;TODO checkboxes whether to save email-template?
        {:keys [kpi-report/email-copy kpi-report/email-title notify?]} (:edit @state)
        msg {:kpi-report/email-title email-title
             :kpi-report/email-copy email-copy
             :notify? (boolean notify?)
             :cycle-id (:db/id cycle)
             :asset-id (:db/id company)}]
    (-> (conn/sendp! :kpi-category/add-report
                     msg)
        (p/then (fn [_]
                  (close!)))
        (p/catch (fn [e]
                   (logging/error "create-kpi-cycle! " e))))))
